import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormView } from "@form/cer-form-view";
import { CerFormViewSet } from "@form/cer-form-view-set";

export class CerAppScheduleTypeForm extends CerFormAdapter {
  
    override viewSetInit(viewSet: CerFormViewSet) {
      const view = this.viewGet();
      viewSet.viewAdd(view);
    }
  
    private viewGet(): CerFormView {
      const view = new CerFormView();
  
      view.viewMetadata = {
      name: 'tidsplaner', dataApiName: 'ScheduleType', text: 'Tidsplaner', textSingular: 'Tidsplan',
      primaryKey: 'id', baseFields: ['id','name','history']
    };

    view.fieldMetadata = [
        { name: 'cron', text: 'Tidsplan (CRON)', required: true}
    ];

    return view;
  }
}
